import { SetupContext } from '@nuxtjs/composition-api'

export default function ({ emit }: SetupContext) {
  const click = (e: MouseEvent) => emit('click', e)
  return {
    click,
  }
}
